export const BROWSE_ADS = 'https://adstudio.spotify.com/dashboard';
// To get an access_token through fetch
export const SPOTIFY_AUTH = 'https://adsmanager.spotify.com/auth';
// To get an access_token through a hash URL redirect
export const SPOTIFY_AUTHORIZE = 'https://accounts.spotify.com/authorize';
// To get user data
export const USER_PROFILE_API = 'https://api.spotify.com/v1/me';
// To get user adStudio accounts array
export const AD_ACCOUNTS_API =
  'https://api-partner.spotify.com/ads/v2/ad_accounts';
// Service to validate google reCaptcha
export const CAPTCHA_VALIDATE = '/validate-captcha';
// To get partner ID for Pendo & GA
export const PARTNER_ID_API =
  'https://spclient.wg.spotify.com/partner-userid/encrypted/googleanalytics-adstudio';
// To get mParticle partner ID
export const MPARTICLE_PARTNER_ID_API =
  'https://spclient.wg.spotify.com/partner-userid/encrypted/mparticle';
